import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SolutionsSection from './components/SolutionsSection';
import ValuesSection from './components/ValuesSection';
import FeaturedProducts from './components/FeaturedProducts';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <>
      <header>
        <h1 className="sr-only">
          <Link to="/" className="cursor-pointer">
            <img
              src="https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/d3b34cfe29fc668c336af62415ef516b.png"
              alt="ADF Biomédical - Fournisseur de dispositifs médicaux en Algérie"
            />
          </Link>
        </h1>
      </header>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <SolutionsSection />
        <ValuesSection />
        <FeaturedProducts />
        <CTASection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
